import { defineComponent as _defineComponent } from 'vue'
import { findComponentBasePath } from 'ah-common-lib/src/helpers/route';
import { AuthorityType } from 'ah-api-gateways';
import { useAuthStore } from '@/app/store/authStore';
import { useIndividualSettingsStore } from '@/app/store/individualSettingsModule';
import { computed, getCurrentInstance, onBeforeMount } from 'vue';
import config from '@/config';


export default /*#__PURE__*/_defineComponent({
  __name: 'TradesSidebarView',
  props: { path: { type: String, required: false, default: '' } },
  setup(__props) {

const props = __props;



const individualSettingsStore = useIndividualSettingsStore();

const authStore = useAuthStore();

const isXhedgeProClient = computed(() => individualSettingsStore.client?.enableXHedgePro);

const isDevOrSit2 = computed(() => config.showDevTools);

onBeforeMount(() => {
  individualSettingsStore.loadClient();
});

// basePath is set on component setup and not expected to react to prop changes
// eslint-disable-next-line vue/no-setup-props-destructure
let basePath = props.path;
const instance = getCurrentInstance();
if (basePath === '' && instance != null) {
  basePath = findComponentBasePath(instance.proxy);
}

return { __sfc: true,props, individualSettingsStore, authStore, isXhedgeProClient, isDevOrSit2, basePath, instance, AuthorityType }
}

})